module.exports = __webpack_public_path__ + "img/funIcon.f07ef264.svg";